import { queryOptions, useQuery } from '@tanstack/react-query';
import { QueryConfig } from '@nohara/react-core';
import { UserEntity, ApiResponse } from '@nohara/oidc-core';

import { api } from '@/lib';

export const getUser = async (userId: string): Promise<UserEntity> => {
  const { data } = await api.get<any, ApiResponse<UserEntity>>(`/users/${userId}`);
  return data;
};

export const getUserQueryOptions = (userId: string | undefined | null) => {
  return queryOptions({
    queryKey: ['user', userId],
    queryFn: () => getUser(userId!),
    enabled: !!userId,
  });
};

type UseUserOptions = {
  queryConfig?: QueryConfig<typeof getUserQueryOptions>;
};

export const useUser = (userId: string | undefined, { queryConfig }: UseUserOptions = {}) => {
  return useQuery({
    ...getUserQueryOptions(userId),
    ...queryConfig,
  });
};
